/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

// Increase max listeners for client-side EventEmitters
if (typeof window !== 'undefined' && window.EventTarget) {
  // Set default max listeners for browser environment
  require('events').EventEmitter.defaultMaxListeners = 20;
}

// Clean up any dangling event listeners on route changes
export const onRouteUpdate = () => {
  // Clean up any existing event listeners that might not have been properly removed
  if (typeof window !== 'undefined') {
    // Remove any stale scroll event listeners
    const scrollHandlers = window._gatsbyScrollHandlers;
    if (scrollHandlers && Array.isArray(scrollHandlers)) {
      scrollHandlers.forEach(handler => {
        window.removeEventListener('scroll', handler);
      });
      window._gatsbyScrollHandlers = [];
    }
  }
};
